import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import useQualityChecklist from "./useSafetyChecklist";
import { Search } from "lucide-react";

const QualityChecklist = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    checklist,
    isChecklistLoading,
    isView,
  } = useQualityChecklist();

  return (
    <div>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Checklist for Safety" />
          {isMobile && !isView && (
            <Button onClick={onAdd} className="px-2">
              + Add Checklist
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && !isView && (
            <Button onClick={onAdd}>+ Add Checklist</Button>
          )}
        </div>
      </div>

      {/* Responsive Table */}
      {isChecklistLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={checklist?.data || []}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      )}
    </div>
  );
};

export default QualityChecklist;
